import { InputHelpMessagePosition, InputState } from '@kubit/web-ui-components/input/types';
import { css } from 'styled-components';
import { InputQuantityVariant } from '../variants';
const COMMON_PROPS = (FOUNDATIONS, FONT) => ({
    leftExtraStyles: css `
    margin-right: ${FOUNDATIONS.spacing_150};
  `,
    rightExtraStyles: css `
    margin-left: ${FOUNDATIONS.spacing_150};
  `,
    helpMessage: {
        position: InputHelpMessagePosition.BOTTOM,
    },
    inputVariant: InputQuantityVariant.DEFAULT,
});
export const getDefaultStyles = (FOUNDATIONS, FONT) => {
    return {
        [InputQuantityVariant.DEFAULT]: {
            [InputState.EMPTY]: {
                ...COMMON_PROPS(FOUNDATIONS, FONT),
            },
            [InputState.FILLED]: {
                ...COMMON_PROPS(FOUNDATIONS, FONT),
            },
            [InputState.ACTIVE]: {
                ...COMMON_PROPS(FOUNDATIONS, FONT),
            },
            [InputState.DISABLED_EMPTY]: {
                ...COMMON_PROPS(FOUNDATIONS, FONT),
            },
            [InputState.DISABLED_FILLED]: {
                ...COMMON_PROPS(FOUNDATIONS, FONT),
            },
            [InputState.DISABLED_FILLED_WITH_INFO]: {
                ...COMMON_PROPS(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_EMPTY]: {
                ...COMMON_PROPS(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_FILLED]: {
                ...COMMON_PROPS(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_ACTIVE]: {
                ...COMMON_PROPS(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_FILLED_WITH_INFO]: {
                ...COMMON_PROPS(FOUNDATIONS, FONT),
            },
        },
    };
};
//# sourceMappingURL=default.js.map